export const ACCEPT_BTN = 'Accept';
export const DECLINE_BTN = 'Decline';
export const SUCCESS = 'Success';
export const CLOSE = 'Close';
export const PREFERENCES_SAVED = 'Your preferences has been saved';

export const PHONE_NUMBER_SAVED =
  'You are now subscribed to text messages. Standard messaging and data rates may apply.';

export const CONTACT_INFO_SAVED = 'Your contact information has been updated.';

export const EMAIL_ADDRESS_SAVED = 'Your email has been verified.';
export const NEW_EMAIL_ADDRESS_SAVED =
  'We’ve updated your contact information with the new email provided.';

export const CANCEL_BTN = 'Cancel';
export const ATTENTION = 'Attention';

export const API_FAILED_TITLE = 'Attention';
export const API_FAILED_CONTENT =
  "We're sorry, but an unexcepted error has occurred. Please try again.";
export const API_FAILED_CONTENTSECOND = 'Please try again';

export const PREFERENCE_SELECT_DESCRIPTION =
  'Please select which item you would like to edit.';

export const EMAIL_SELECT_DESCRIPTION =
  'To send you email communications, we’ll need to verify your email. Please enter it below.';

export const CUSTOMER_SUPPORT_TITLE = 'Oops!';
export const CUSTOMER_SUPPORT_DESCRIPTION =
  'After three unsuccessful attempts, we limit access for your privacy. For further assistance, please call the number on the back of your ID card or send us a message via the Support page.';

// export const CUSTOMER_SUPPORT_DESCRIPTION =
//   "Something went wrong, but we'd like to make it right. For further assistance, please call the number on the back of your ID card or send us a message via the Support page.";

export const EMAIL_BTN_TEXT = 'Email Address';
export const PHONE_BTN_TEXT = 'Phone Number';

export const FAILURE_CONTENT_DESELCT =
  'You have selected a non-electronic communication method. This will deselect your preference for paperless communication. Do you wish to proceed?';

/* Confirmation text Code */

export const EMAIL_CONFIRMATION_SENDBTN = 'Send Code';
export const EMAIL_CONFIRMATION_DIFFBTN = 'Use a Different Email';
export const EMAIL_CONFIRMATION_CODE_DESCRIPTION =
  'We have sent a confirmation code to raquel323@gmail.com. Please enter it below.';

/* communication main page text */

export const SAVE_BTN = 'Save Changes';
export const PHONE_SAVE_BTN = 'Save';
export const CONFIRM_EMAIL_BTN = 'Confirm Email';
export const ALERT_MODAL_TEXT =
  'This will deselect your preference for paperless communication. Would you like to proceed?';
export const VERIFY_CODE = 'Verify Code';
export const RESEND_CODE = 'Resend Code';

export const OK = 'OK';
export const YES = 'YES';
export const NO = 'NO';

export const MOBILE_PHONE_DESCRIPTION =
  'Please enter a valid mobile phone number to receive text messages. Standard messaging and data rates apply.';
export const WORK_PHONE_DESCRIPTION =
  'This contact method is unavailable because there is not a work phone number associated with this account. Please enter one below.';
export const HOME_PHONE_DESCRIPTION =
  'This contact method is unavailable because there is not a home phone number associated with this account. Please enter one below.';

/* Preference Text */

export const NEW_EMAIL_CONFIRM =
  'Please note that the new email address you verify will become the primary email address for your account.';

export const CONTINUE_DESCRIPTION = 'Do you wish to continue?';

export const RESEND_DESCRIPTION =
  'If you cannot locate the email with the code, please check your spam or junk folder.';

export const OPPS = 'Oops!';

export const EDIT_TEXT = 'Edit Contact Information';
export const OPEN_ERROR_MODAL = 'Open Error Modal';
export const WENT_WRONG = 'Oops! Something went wrong.';
export const ERROR_MESSAGE =
  'We’re sorry, but an unexpected error has occurred';
export const PLEASE_TRY_AGAIN = 'Please try again';
